import { extend } from 'vee-validate';
import CorporationService from '@/services/CorporationService';

extend('corporation_id_unique', {
  validate: (id) => {
    return CorporationService.validateId(id)
      .then((response) => {
        return {
          valid: response.data.isValid,
        };
      })
      .catch(() => {
        return {
          valid: false,
        };
      });
  },
});
